module.exports = __webpack_public_path__ + "img/tu5.f8b26df6.png";